import { FunctionComponent } from "react";
import { useOpenSupportTicketsCount } from "./use-open-support-tickets-count";

interface SupportTicketsCountBadgeProps {}

const SupportTicketsCountBadge: FunctionComponent<SupportTicketsCountBadgeProps> = () => {
  const count = useOpenSupportTicketsCount();

  return !count ? null : (
    <div className="w-4 h-4 font-medium text-white rounded-full flex items-center justify-center bg-[#E95C5C] text-[11px] mr-5">
      {count}
    </div>
  );
};

export default SupportTicketsCountBadge;
